import { Component, type ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

interface State { error: Error | null }

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State { return { error }; }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="fatal-error">
        <AlertTriangle size={34} />
        <h1>RealImager needs a fresh start</h1>
        <p>Your local projects are still on this device. Reload the app to continue.</p>
        <button type="button" onClick={() => window.location.reload()}>Reload RealImager</button>
        <details><summary>Technical details</summary><pre>{this.state.error.message}</pre></details>
      </main>
    );
  }
}
